import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import defaultJobImage from '../../../images/default_skill.jpeg';
import { dayMonthDate } from '../../../constants/date';
import { renderDateWithTimeZone } from '../../../helpers/timezones';
import { appPath } from '../../../constants';

export default class JobChatHeader extends Component {
  render () {
    const { job: { id, icon_url, start_date, time_zone_id }, participants } = this.props.conversation;
    const jobStartDate = renderDateWithTimeZone(start_date, dayMonthDate, time_zone_id);
    const participantsNames = participants.map(part => `${part.first_name} ${part.last_name}`);
    return (
      <div className='job-chat-header-info d-flex align-items-center justify-content-center'>
        <Link
          to={`/${appPath}/jobs/${id}`}
          className='job-image'
          style={{ backgroundImage: `url('${icon_url || defaultJobImage}')` }}
        />
        <div className='mx-3'>
          <div className='date-participants-wrapper'>
            <h4 className='title mr-2'>{ jobStartDate }</h4>
            <h5 className='participants-names text-muted text-ellipsis'>{participantsNames.join(', ')}</h5>
          </div>
          <h5 className='text-muted'>{ participants.length } { participants.length === 1 ? 'member' : 'members'}</h5>
        </div>
      </div>
    );
  }
}

JobChatHeader.propTypes = {
  conversation: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/common/ui/JobChatHeader.js